import { createGlobalStyle } from 'styled-components';

export const LayoutStyle = createGlobalStyle`
  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    
    
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
      
  }

  .ant-menu-sub {
    .ant-menu-item {
      height: 45px !important;
      line-height: 45px !important;

      &:hover {
        background-color: transparent !important;
        color: var(--primary) !important;

        svg {
          color: var(--primary) !important;
        }
      }
    }

    .ant-menu-item-selected {
      background-color: white !important;
      color: var(--primary) !important;

      svg {
        color: var(--primary) !important;
      }
    }
    .ant-menu-title-content {
      margin-inline-start: 16px !important;
    }
  }

  .footer-sidebar-avatar {
    .footer-lang-wrap {
      display: flex;
      align-items: center;
    }

    .footer-lang-active {
      background-color: var(--primary);
      color: #ffffff;
      border-radius: 4px;
      padding: 1px 5px;
    }

    .footer-lang {
      color: var(--primary);
      padding: 1px 5px;
    }
  }


  /*display*/
  .d-flex {
    display: flex;
  }
  .align-items-center {
    align-items: center;
  }
  
  .flex-direction-col {
    display: flex;
    flex-direction: column;
  }

  .space-between {
    align-items: center;
    justify-content: space-between;
  }

  .flex-1 {
    flex: 1;
  }

  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .flex-center-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .flex-start-between {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .flex-end {
    align-items: center;
    justify-content: flex-end
  }

  .align-items-end {
    align-items: flex-end;
  }

  .d-desktop {
    display: block;
  }

  .d-mobile {
    display: none;
    @media (max-width: 768px) {
      display: block;
    }
  }
  .d-none {
    display:none;
  }
  @media (max-width: 768px) {
    .d-desktop {
      display: none;
    }
    .d-mobile {
        display: block;
    }
  }

  .bg-primary {
    background: var(--bg-primary);
    background-color: var(--bg-primary);
  }

  .wrap {
    flex-wrap: wrap;
  }
  .ql-editor {
    min-height:300px;
  }

  /*position*/
  .absolute {
    position: absolute;
  }
  .relative {
    position: relative;
  }
  .top-0 {
    top: 0;
  }
  .right-4 {
    right: 1rem;
  }

  /*style*/
  .btn-action-head {
    padding: 0 7px;
    font-size: 14px;
    line-height: normal;
    height: 32px;
    font-weight: 500;
  }
  #copy-input {
    position: fixed;
    z-index: 0;
  }
  .location-default-text {
    background-color: var(--light-primary);
    color: var(--primary);
    border-radius: 5px;
    padding: 3px 5px;
    font-size: 8px;
    margin-top: 5px;
    width: max-content;
  }
  .showModal-content {
    overflow: auto;
    padding-bottom: 10px;
    height: calc(100vh - 57px - 36px - 60px - 10px);
  }
  .component-selected {
    border: 1px solid #d1d1d1;
  }
  
.ellipsis {
  display: inline;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;/* Important for long words! */
}
`;
